"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_VALUE_SRC = exports.SET_VALUE = exports.SET_TREE = exports.SET_OPERATOR_OPTION = exports.SET_OPERATOR = exports.SET_NOT = exports.SET_FIELD = exports.SET_DRAG_START = exports.SET_DRAG_PROGRESS = exports.SET_DRAG_END = exports.SET_CONJUNCTION = exports.REMOVE_RULE = exports.REMOVE_GROUP = exports.PLACEMENT_PREPEND = exports.PLACEMENT_BEFORE = exports.PLACEMENT_APPEND = exports.PLACEMENT_AFTER = exports.MOVE_ITEM = exports.ADD_RULE = exports.ADD_GROUP = void 0;
var ADD_GROUP = "ADD_GROUP";
exports.ADD_GROUP = ADD_GROUP;
var REMOVE_GROUP = "REMOVE_GROUP";
exports.REMOVE_GROUP = REMOVE_GROUP;
var SET_CONJUNCTION = "SET_CONJUNCTION";
exports.SET_CONJUNCTION = SET_CONJUNCTION;
var SET_NOT = "SET_NOT";
exports.SET_NOT = SET_NOT;
var ADD_RULE = "ADD_RULE";
exports.ADD_RULE = ADD_RULE;
var REMOVE_RULE = "REMOVE_RULE";
exports.REMOVE_RULE = REMOVE_RULE;
var SET_FIELD = "SET_FIELD";
exports.SET_FIELD = SET_FIELD;
var SET_OPERATOR = "SET_OPERATOR";
exports.SET_OPERATOR = SET_OPERATOR;
var SET_VALUE = "SET_VALUE";
exports.SET_VALUE = SET_VALUE;
var SET_VALUE_SRC = "SET_VALUE_SRC";
exports.SET_VALUE_SRC = SET_VALUE_SRC;
var SET_OPERATOR_OPTION = "SET_OPERATOR_OPTION";
exports.SET_OPERATOR_OPTION = SET_OPERATOR_OPTION;
var SET_TREE = "SET_TREE";
exports.SET_TREE = SET_TREE;
var MOVE_ITEM = "MOVE_ITEM";
exports.MOVE_ITEM = MOVE_ITEM;
var PLACEMENT_AFTER = "after";
exports.PLACEMENT_AFTER = PLACEMENT_AFTER;
var PLACEMENT_BEFORE = "before";
exports.PLACEMENT_BEFORE = PLACEMENT_BEFORE;
var PLACEMENT_APPEND = "append";
exports.PLACEMENT_APPEND = PLACEMENT_APPEND;
var PLACEMENT_PREPEND = "prepend";
exports.PLACEMENT_PREPEND = PLACEMENT_PREPEND;
var SET_DRAG_PROGRESS = "SET_DRAG_PROGRESS";
exports.SET_DRAG_PROGRESS = SET_DRAG_PROGRESS;
var SET_DRAG_START = "SET_DRAG_START";
exports.SET_DRAG_START = SET_DRAG_START;
var SET_DRAG_END = "SET_DRAG_END";
exports.SET_DRAG_END = SET_DRAG_END;